"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardEventBus = void 0;
var rxjs_1 = require("rxjs");
var widgetChangeContentSubject = new rxjs_1.Subject();
var startSavingParametersForWidgetSubject = new rxjs_1.Subject();
var stopConfiguringParametersSubject = new rxjs_1.Subject();
var toggleEditModeSubject = new rxjs_1.Subject();
var dashboardLoadingSubect = new rxjs_1.BehaviorSubject(false);
exports.DashboardEventBus = {
    emitWidgetChangeContent: function (widgetId, widgetType) {
        widgetChangeContentSubject.next({ widgetId: widgetId, widgetType: widgetType });
    },
    onWidgetChangeContent: function () {
        return widgetChangeContentSubject.asObservable();
    },
    emitStartSavingParametersForWidget: function (widgetId, onCompleteAsync) {
        startSavingParametersForWidgetSubject.next({ widgetId: widgetId, onCompleteAsync: onCompleteAsync });
    },
    onStartSavingParametersForWidget: function () {
        return startSavingParametersForWidgetSubject.asObservable();
    },
    emitStopConfiguringParameters: function () {
        stopConfiguringParametersSubject.next();
    },
    onStopConfiguringParameters: function () {
        return stopConfiguringParametersSubject.asObservable();
    },
    emitToggleEditMode: function (editModeEnabled) {
        toggleEditModeSubject.next(editModeEnabled);
    },
    onToggleEditMode: function () {
        return toggleEditModeSubject.asObservable();
    },
    emitDashboardLoading: function (loading) {
        dashboardLoadingSubect.next(loading);
    },
    onDashboardLoading: function () {
        return dashboardLoadingSubect.asObservable();
    }
};
